import FormLayout from "components/form/FormLayout";
import Input from "components/form/input";
import React from "react";
import { IPutTeeSheetSettings } from "api/rpc/2024-04/facilityAdmin/facility/settings";
import { useTranslation } from "react-i18next";
import Toggle from "components/form/toggle/Toggle";

interface IProps {
    state: Partial<IPutTeeSheetSettings>;
    updateState: <K extends keyof IPutTeeSheetSettings>(key: K, value: IPutTeeSheetSettings[K]) => void;
}

export default function FacilityAccessControlSettings(props: IProps) {
    const { state, updateState } = props;
    const { t } = useTranslation();

    return (
        <div className="p-2">
            <FormLayout>
                <FormLayout.Group>
                    <Toggle
                        label={t("Restrict Staff Login by Location")}
                        onChange={e => updateState("facility_login_radius_enabled", e.target.checked)}
                        checked={state?.facility_login_radius_enabled}
                        tooltip={t("Require staff to be within a specified distance of the facility in order to log in.")}
                    />
                    {state?.facility_login_radius_enabled ? (
                        <Input
                            label={t("Login Radius (meters)")}
                            type="number"
                            id="facility_login_radius_meters"
                            value={state?.facility_login_radius_meters ?? ""}
                            suffix={t("m")}
                            placeholder={"100"}
                            tooltipText={t("Staff must be within this distance of the facility to log in. Location accuracy may vary. We recommend at least 50-100 meters. Users with permission to bypass location restrictions are not affected")}
                            onChange={e => updateState("facility_login_radius_meters", e.target?.value)}
                        />
                    ) : null}
                </FormLayout.Group>
            </FormLayout>
        </div>
    );
}